__turbopack_context__.v({
  "bars": "SourcesBars-module__t66Tqq__bars",
  "caption": "SourcesBars-module__t66Tqq__caption",
  "column": "SourcesBars-module__t66Tqq__column",
  "columns": "SourcesBars-module__t66Tqq__columns",
  "legend": "SourcesBars-module__t66Tqq__legend",
  "legendItem": "SourcesBars-module__t66Tqq__legendItem",
  "month": "SourcesBars-module__t66Tqq__month",
  "monthWord": "SourcesBars-module__t66Tqq__monthWord",
  "note": "SourcesBars-module__t66Tqq__note",
  "noteArrow": "SourcesBars-module__t66Tqq__noteArrow",
  "noteIcon": "SourcesBars-module__t66Tqq__noteIcon",
  "noteText": "SourcesBars-module__t66Tqq__noteText",
  "notesMonth": "SourcesBars-module__t66Tqq__notesMonth",
  "notesStacked": "SourcesBars-module__t66Tqq__notesStacked",
  "plot": "SourcesBars-module__t66Tqq__plot",
  "segment": "SourcesBars-module__t66Tqq__segment",
  "stack": "SourcesBars-module__t66Tqq__stack",
  "swatch": "SourcesBars-module__t66Tqq__swatch",
  "total": "SourcesBars-module__t66Tqq__total",
  "unit": "SourcesBars-module__t66Tqq__unit",
});
